import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import styled from 'styled-components';
import { OPTION_GROUPS_MODALS } from '../../constants';
import AddButton from '../shared/AddButton';
import OptionGroupSelectedModal from './components/option-group-selected-modal';

const Header = styled.h1`
  font-family: Geomanist;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  line-height: 25px;
  text-align: center;
  letter-spacing: -0.4px;
  margin-bottom: 0px;
`;

const Border = styled.div`
  height: 1px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid #eeeeee;
`;

const OptionGroupListModal = ({
  setSelectedDialog,
  setGroupToEdit,
  groups,
  menus,
  isManageMode,
  setSelectedOptionGroup,
  selectedOptionGroup,
}) => {
  return (
    <React.Fragment>
      <DialogTitle
        id="responsive-dialog-title"
        style={{ paddingTop: '50px', paddingBottom: '25px' }}
      >
        <Header>Customisation Options</Header>
      </DialogTitle>
      <Border />

      {Boolean(groups.length > 0) && (
        <React.Fragment>
          {groups.map(group => {
            return (
              <OptionGroupSelectedModal
                group={group}
                setGroupToEdit={setGroupToEdit}
                setSelectedDialog={setSelectedDialog}
                menus={menus}
                isManageMode={isManageMode}
                selectedOptionGroup={selectedOptionGroup}
                setSelectedOptionGroup={setSelectedOptionGroup}
              />
            );
          })}
        </React.Fragment>
      )}

      <DialogActions
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '25px',
          marginBottom: '50px',
        }}
      >
        <AddButton
          onClick={() => {
            setSelectedDialog(OPTION_GROUPS_MODALS.CREATE);
          }}
        >
          Create a group
        </AddButton>
      </DialogActions>
    </React.Fragment>
  );
};

export default OptionGroupListModal;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/GlobalOptions/option-group-list-modal.jsx